import { getTierStyle } from "@/lib/verdictStyles";

export default function SourceItem({ source, index }) {
  const tier = getTierStyle(source.tier);
  const stanceLabel = {
    supports: "SUPPORTS",
    contradicts: "REFUTES",
    neutral: "CONTEXT",
  }[source.stance] || "CONTEXT";
  const stanceColor = {
    supports: "text-emerald-700",
    contradicts: "text-red-700",
    neutral: "text-stone-600",
  }[source.stance] || "text-stone-600";

  return (
    <a
      href={source.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`source-link-${index}`}
      className={`group block border-l-4 ${tier.border} bg-white pl-4 pr-4 py-3 hover:bg-zinc-50 transition-colors`}
    >
      <div className="flex items-center justify-between mb-1">
        <span className={`font-mono-plex text-[10px] ${tier.text} font-semibold`}>
          {tier.label}
        </span>
        <span className={`font-mono-plex text-[10px] ${stanceColor} font-semibold`}>
          {stanceLabel}
        </span>
      </div>
      <div className="font-display text-[15px] text-zinc-950 leading-snug group-hover:underline decoration-2 underline-offset-2">
        {source.title || source.domain}
      </div>
      {source.excerpt && (
        <p className="text-[13px] text-zinc-600 mt-1 leading-relaxed line-clamp-2">
          &ldquo;{source.excerpt}&rdquo;
        </p>
      )}
      <div className="mt-2 font-mono-plex text-[10px] text-zinc-500">
        {source.domain || source.publication}
      </div>
    </a>
  );
}
